import './Footer.css'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li><a href="#party">Party Sound Services</a></li>
            <li><a href="#karaoke">Karaoke Sound Services</a></li>
            <li><a href="#wedding">Wedding Sound Services</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect With Us</h3>
          <ul>
            <li><a href="#facebook">Facebook</a></li>
            <li><a href="#younow">Younow</a></li>
            <li><a href="#kick">Kick</a></li>
            <li><a href="#live">Live Streaming</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact</h3>
          <ul>
            <li><a href="tel:0815436748">📞 081 543 6748</a></li>
            <li><a href="mailto:[email protected]">✉️ [email protected]</a></li>
            <li>📍 Tzaneen & Limpopo Area, South Africa</li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Founded in 2022 • Bringing the Tzaneen community together</p>
        <p>&copy; {currentYear} Soundmaster. All rights reserved.</p>
      </div>
    </footer>
  )
} 